import React from 'react';
import './SuccessScreen.css';

const SuccessScreen = ({ onNext, onBack, onDataUpdate, data }) => {
  return (
    <div className="success-screen">
      <h1>Success!</h1>
      <p>Coming soon...</p>
      <div className="form-actions">
        <button onClick={onBack} className="back-button">
          Back
        </button>
        <button onClick={onNext} className="next-button">
          Next
        </button>
      </div>
    </div>
  );
};

export default SuccessScreen; 